// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { GroupDetailsFacadeService } from './../../../state/group-details/group-details.facade';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription, zip } from 'rxjs';
import { map, take, filter, tap } from 'rxjs/operators';
import {
  needsLoading,
  Loadable,
  Loaded,
  IAMUser,
  MaybeLoadable,
  readParameterFromRouterState,
  IAM_ROUTE,
  GoAction,
  QueueAlertAction,
  AlertType
} from '@app/core';
import { GroupDetail, Group } from '@app/access-management/core/models/groups.model';
import { selectGroupDetail } from '@app/access-management/state/group-details/group-details.selectors';
import {
  LoadingGroupDetailsAction,
  SelectUsersForGroupAction,
  ClearGroupUserSelectionsAction
} from '@app/access-management/state/group-details/group-details.actions';
import { selectUsers, selectSelectedUsers, LoadingUsersAction } from '@app/access-management/state';
import { State } from '../../../state/index';
import { GroupsService } from '../../../core/services/group.service';
import { GroupUser } from '../../../core/models/groups.model';
import { SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';

@Component({
  selector: 'app-group-users-form',
  templateUrl: './group-users-form.component.html',
  styleUrls: ['./group-users-form.component.scss']
})
export class GroupUsersFormComponent implements OnInit {
  readonly group$: Observable<Group | undefined>;
  private groupId: any;

  userTableColumns = [
    { name: 'Username', prop: 'username' },
    { name: 'Name', prop: 'name' },
    { name: 'Email', prop: 'email' }
  ];
  groupUsers$: any;
  selectedUsers: any;

  constructor(
    activatedRoute: ActivatedRoute,
    private store: Store<State>,
    private groupDetailsFacadeService: GroupDetailsFacadeService,
    private groupService: GroupsService
  ) {
    this.groupId = readParameterFromRouterState(activatedRoute, 'id');
    this.groupDetailsFacadeService.initialize(this.groupId);
    this.group$ = this.groupDetailsFacadeService.groupDetails$;

    this.groupUsers$ = this.groupService.getGroupUsers(this.groupId);
  }

  ngOnInit() {}

  onSelectUser({ selected }: SelectedRows) {
    this.selectedUsers = selected;
  }

  saveUsersForGroup() {
    if (!this.selectedUsers) {
      return;
    }
    const usernames = this.selectedUsers.map((item: any) => item.username);
    this.groupService.addUserToGroup(this.groupId, { usernames }).subscribe(
      () => {
        this.goToGroupDetailsPage();
        this.store.dispatch(new LoadingGroupDetailsAction(this.groupId));
        this.store.dispatch(
          new QueueAlertAction({
            alertText: `Users have successfully been assigned to this role.`,
            alertType: AlertType.SUCCESS
          })
        );
      },
      error => {
        this.store.dispatch(new QueueAlertAction({ alertText: error.message, alertType: AlertType.ERROR }));
      }
    );

    this.store.dispatch(
      new SelectUsersForGroupAction({
        groupId: this.groupId,
        selectedUsers: this.selectedUsers
      })
    );
  }

  cancel() {
    this.store.dispatch(new ClearGroupUserSelectionsAction(this.groupId));
    this.goToGroupDetailsPage();
  }

  goToGroupDetailsPage() {
    this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'groups', this.groupId]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/groups/group-details/group-users-form/group-users-form.component.ts